/* ============================================================================
   Biblio Bookstore - "Living Cover" 3D tilt          (custom, not theme code)
   ----------------------------------------------------------------------------
   Book covers lean toward the cursor in 3D, with a moving glare across the
   surface and a shadow that grows toward the lifted edge and settles when the
   cover goes flat. On load, covers in view do one slow tease sway so people
   discover the effect without being told.

   SAFETY NOTES (learned the hard way on this theme - please keep):
   - This file NEVER sets width/height/object-fit/display on a cover image.
     Doing that inside the home carousels breaks the swiper's width math and
     the covers go blank. We only set `transform` and `filter`, which do not
     affect layout at all.
   - Home product carousels are deliberately EXCLUDED from the selector list
     below. Do not add them without testing live.
   - The glare is an absolutely positioned element with pointer-events:none,
     so it never intercepts clicks on the product link.

   TUNING: the CFG block below is the whole control panel. Bob's knobs are
   MAX_TILT, GLARE_ALPHA, SHADOW_STRENGTH and TEASE.
   Keep this file ASCII-only - fancy characters get mangled on paste.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = {
    MAX_TILT: 20,          // degrees of lean at the far edge of the cover
    PERSPECTIVE: 900,      // px; lower = more dramatic 3D
    LIFT: 14,              // px the cover rises toward the viewer on hover
    GLARE_ALPHA: 0.55,     // peak brightness of the moving sheen (0 - 1)
    SHADOW_STRENGTH: 0.34, // peak darkness of the cast shadow (0 - 1)
    SHADOW_SPREAD: 26,     // px the shadow travels toward the lifted edge
    EASE_IN: 90,           // ms to settle onto the cursor
    EASE_OUT: 520,         // ms to fall back flat when the cursor leaves
    TEASE: true,           // one slow sway on load, for discoverability
    TEASE_DELAY: 900,      // ms after load before the tease starts
    TEASE_DURATION: 2400,  // ms the tease sway takes
    TEASE_MAX: 6           // how many covers tease (nearest the top first)
  };

  // Covers we are allowed to touch. Home carousels are intentionally absent.
  var SCOPES = [
    '.grid.product-collection:not(.product-list-style) .product-grid-item .reveal img',
    '.grid.product-collection:not(.product-list-style) .product-grid-item .products a img',
    '.product-recommendations .product-grid-item .reveal img',
    '.related-products-container .product-grid-item .reveal img',
    '.product_image_width img.product-item-img',
    '.product_image_width .product-item-img img'
  ];

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = !window.matchMedia ||
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Touch devices get no tilt (there is no cursor to lean toward), and we
  // honour a reduced-motion preference by staying out entirely.
  if (reduceMotion || !finePointer) return;

  injectStyles();

  var teased = 0;

  function injectStyles() {
    var css =
      '.bx3d{will-change:transform;backface-visibility:hidden}' +
      '.bx3d-glare{position:absolute;pointer-events:none;opacity:0;' +
      'border-radius:3px;mix-blend-mode:screen;z-index:2;' +
      'transition:opacity 220ms ease}' +
      '.bx3d-host{position:relative}';
    var el = document.createElement('style');
    el.setAttribute('data-biblio', 'cover-3d');
    el.appendChild(document.createTextNode(css));
    document.head.appendChild(el);
  }

  function covers() {
    var out = [];
    var seen = [];
    SCOPES.forEach(function (sel) {
      var found;
      try {
        found = document.querySelectorAll(sel);
      } catch (e) {
        return;
      }
      Array.prototype.forEach.call(found, function (img) {
        if (seen.indexOf(img) === -1) {
          seen.push(img);
          out.push(img);
        }
      });
    });
    return out;
  }

  function setup(img) {
    if (img.getAttribute('data-bx3d') === '1') return;
    img.setAttribute('data-bx3d', '1');
    img.classList.add('bx3d');

    // The element the glare is positioned inside. We use the image's parent so
    // the glare tracks the cover, not the whole (wider) grid cell.
    var host = img.parentElement;
    if (!host) return;
    host.classList.add('bx3d-host');

    var glare = document.createElement('i');
    glare.className = 'bx3d-glare';
    host.appendChild(glare);

    // The card is the hover target: leaning should start as soon as the
    // cursor is anywhere over the cell, not only over the cover itself.
    var card = img.closest('.product-grid-item') ||
               img.closest('.product-item-img') || host;

    var raf = null;
    var pending = null;

    function place() {
      // Line the glare up with the cover's real box each time we enter, since
      // the cover size varies per book (contain-fitted, ragged aspect ratios).
      var ir = img.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      if (!ir.width || !ir.height) return false;
      glare.style.left = (ir.left - hr.left) + 'px';
      glare.style.top = (ir.top - hr.top) + 'px';
      glare.style.width = ir.width + 'px';
      glare.style.height = ir.height + 'px';
      return true;
    }

    function apply(px, py, instant) {
      // px, py are -1 .. 1 from the centre of the cover.
      // Signs matter and are easy to get backwards. In CSS, +rotateX pushes the
      // TOP away from the viewer and brings the bottom forward; +rotateY pushes
      // the RIGHT edge away. To make the corner nearest the cursor rise TOWARD
      // it, both need the opposite sign to the cursor offset.
      var ry = -px * CFG.MAX_TILT;       // cursor right -> right edge forward
      var rx = py * CFG.MAX_TILT;        // cursor top   -> top edge forward
      var dur = instant ? CFG.EASE_IN : CFG.EASE_OUT;

      var t = 'perspective(' + CFG.PERSPECTIVE + 'px) ' +
              'rotateX(' + rx.toFixed(2) + 'deg) ' +
              'rotateY(' + ry.toFixed(2) + 'deg) ' +
              'translateZ(' + (CFG.LIFT).toFixed(1) + 'px)';

      // Shadow leans opposite the lift, so the lifted edge throws it further.
      var sx = (-px * CFG.SHADOW_SPREAD).toFixed(1);
      var sy = (Math.abs(py) * 6 + 10 - py * CFG.SHADOW_SPREAD * 0.5).toFixed(1);
      var blur = (16 + Math.abs(px) * 10 + Math.abs(py) * 10).toFixed(1);
      var alpha = (0.16 + (Math.abs(px) + Math.abs(py)) * 0.5 * CFG.SHADOW_STRENGTH)
        .toFixed(3);

      img.style.transition = 'transform ' + dur + 'ms cubic-bezier(.22,.61,.36,1), ' +
                             'filter ' + dur + 'ms ease';
      img.style.transform = t;
      img.style.filter = 'drop-shadow(' + sx + 'px ' + sy + 'px ' + blur + 'px rgba(0,0,0,' + alpha + '))';

      // Sheen sweeps across the face, brightest where the cover faces us.
      var gx = ((px + 1) / 2 * 100).toFixed(1);
      var gy = ((py + 1) / 2 * 100).toFixed(1);
      glare.style.transition = 'opacity 220ms ease, background ' + dur + 'ms ease';
      glare.style.background =
        'radial-gradient(circle at ' + gx + '% ' + gy + '%, ' +
        'rgba(255,255,255,' + CFG.GLARE_ALPHA + ') 0%, ' +
        'rgba(255,255,255,' + (CFG.GLARE_ALPHA * 0.35).toFixed(3) + ') 32%, ' +
        'rgba(255,255,255,0) 68%)';
      glare.style.transform = t;
    }

    function rest() {
      img.style.transition = 'transform ' + CFG.EASE_OUT + 'ms cubic-bezier(.22,.61,.36,1), ' +
                             'filter ' + CFG.EASE_OUT + 'ms ease';
      // Keep an explicit identity transform so the theme's own hover zoom
      // (reveal.zoom_in scales the image) cannot fight with ours.
      img.style.transform = 'perspective(' + CFG.PERSPECTIVE + 'px) rotateX(0deg) rotateY(0deg) translateZ(0)';
      img.style.filter = 'drop-shadow(0 5px 7px rgba(0,0,0,0.28))';
      glare.style.opacity = '0';
      glare.style.transform = img.style.transform;
    }

    function onMove(e) {
      pending = e;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var ev = pending;
        if (!ev) return;
        var r = img.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var px = (ev.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var py = (ev.clientY - (r.top + r.height / 2)) / (r.height / 2);
        px = Math.max(-1, Math.min(1, px));
        py = Math.max(-1, Math.min(1, py));
        apply(px, py, true);
      });
    }

    card.addEventListener('mouseenter', function () {
      if (place()) glare.style.opacity = '1';
    });
    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseleave', function () {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      pending = null;
      rest();
    });

    rest();

    if (CFG.TEASE && teased < CFG.TEASE_MAX) {
      teased++;
      teaseOnce(img, glare, place, apply, rest);
    }
  }

  // One slow lean-and-return so the effect is discoverable without a hover.
  function teaseOnce(img, glare, place, apply, rest) {
    setTimeout(function () {
      var r = img.getBoundingClientRect();
      var onScreen = r.top < window.innerHeight && r.bottom > 0;
      if (!onScreen || !place()) return;

      var start = null;
      glare.style.opacity = '1';

      function step(ts) {
        if (start === null) start = ts;
        var t = (ts - start) / CFG.TEASE_DURATION;
        if (t >= 1) { rest(); return; }
        // Out to one side and back, fading as it returns.
        var swing = Math.sin(t * Math.PI) * 0.75;
        apply(swing, -0.18 * Math.sin(t * Math.PI), false);
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, CFG.TEASE_DELAY);
  }

  function scan() {
    covers().forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Collection filtering, load-more and quick-view all swap markup in after
  // load, so pick up any covers that appear later.
  if (window.MutationObserver) {
    var pendingScan = null;
    new MutationObserver(function () {
      if (pendingScan) clearTimeout(pendingScan);
      pendingScan = setTimeout(scan, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();